export default __webpack_public_path__ + "static/media/photo--sm--27.0db0c0b9.jpg";